/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */

import DEFAULT_CONFIG from "./settings.js";

export function get_types() {
    return Object.keys(get_config().types);
}

export function get_type_config(type) {
    const config = {};
    if (get_config().types[type]) {
        Object.assign(config, get_config().types[type]);
    }
    if (config.type) {
        const props = get_type_config(config.type);
        Object.assign(props, config);
        return props;
    } else {
        return config;
    }
}

function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}

function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

export function override_config(config) {
    if (globalThis.__PERSPECTIVE_CONFIG__) {
        console.warn("Config already initialized!");
    }
    globalThis.__PERSPECTIVE_CONFIG__ = mergeDeep(DEFAULT_CONFIG, config);
}

export function get_config() {
    if (!globalThis.__PERSPECTIVE_CONFIG__) {
        globalThis.__PERSPECTIVE_CONFIG__ = mergeDeep(
            DEFAULT_CONFIG,
            globalThis.__TEMPLATE_CONFIG__ || {}
        );
    }
    return globalThis.__PERSPECTIVE_CONFIG__;
}
